/*
* Project: LegalPlace assistant
* File: src\components\control_bar.js
* Author: Nasreddine DAIFALLAH
* Version: 1.0
*/
import React, { Component } from 'react';
import { connect } from 'react-redux';

import AnimateHeight from 'react-animate-height';
import { unraiseError } from '../errors/error';
import { _lp } from '../logic/wording';

class _LpErrorBar extends Component {
  static hideError() {
    unraiseError('global');
  }

  constructor(props) {
    super(props);
    this.in = false;
  }

  componentDidMount() {
    if (this.refs.me) document.getElementById('errors-bar').appendChild(this.refs.me);
  }

  render() {
    let height = this.props.error_code > 0 ? 'auto' : 0;
    if (typeof height === 'undefined') height = 0;
    // console.log(height)
    // <AnimateHeight height={height} duration={400}>
    // </AnimateHeight>
    // console.log(this.props.error_code)
    return (
      <div ref="me">
        <AnimateHeight height={height} duration={400}>
          <div className="error notification-bar in">
            <div className="nb-container container">
              <p ref="text">
                {_lp('Erreur : ') + this.props.error_message}
              </p>
              <div className="nb-x icn-x" onClick={_LpErrorBar.hideError} />
            </div>
          </div>
        </AnimateHeight>
      </div>
    );
  }
}


const mapStateToProps = state => ({
  error_code: state.errors.code,
  error_message: state.errors.message,
});

const mapDispatchToProps = () => ({

});

const LpErrorBar = connect(mapStateToProps, mapDispatchToProps)(_LpErrorBar);

export default LpErrorBar;



// WEBPACK FOOTER //
// ./src/components/error_bar.js